export const isCheckbox = (element:HTMLInputElement) => element.type === 'checkbox';
export const isMultiSelect = (element:HTMLSelectElement) => element.options && element.multiple;

export const getSelectValues = (options:NodeListOf<HTMLSelectElement>) => [].reduce.call(options, (values, option:HTMLOptionElement) => {
    return option.selected ? values.concat(option.value) : values;
}, []);

export const isValidValue = (element:HTMLInputElement) => {
    return !['checkbox', 'radio'].includes(element.type) || element.checked;
};

export const isValidElement = (element:HTMLInputElement) => {
    return element.name && element.value;
};

export default (elements:NodeListOf<HTMLElement>|HTMLElement) => [].reduce.call(elements, (data, element) => {
    if (isValidElement(element) && isValidValue(element)) {
        if (isCheckbox(element)) {
            data[element.name] = (data[element.name] || []).concat(element.value);
        } else if (isMultiSelect(element)) {
            data[element.name] = getSelectValues(element);
        } else {            
            data[element.name] = element.value;
        }
    }
    return data;
}, {});
